import _ from '@/utils/lodash-optimized'
import React from 'react'
import { connect } from 'react-redux'

import { withLegacyRouter } from '../../../decorators'
import Document from '../../shared/DocumentViewer/document'
import { Paper, CircularProgress } from '../../shared/NarusMaterial'
import {
  encounterSign,
  getGrandRoundsSummary
} from '../actions'
import { SignEncounterForm } from '../SignEncounter'

class RenderDoc extends React.Component {
  UNSAFE_componentWillMount () {
    const { dispatch, encounter } = this.props
    dispatch(getGrandRoundsSummary(encounter.subject_id, encounter.id))
  }

  render () {
    const { loading, data } = this.props
    if (loading || !data) {
      return <CircularProgress />
    }
    return (
      <div
        className='row pdf-gutter'
        style={{
          background: '#DDD',
          marginBottom: '20px'
        }}
      >
        <div className='col-xs-1 pdf-gutter' />
        <div className='col-xs-10'>
          <Document
            hasStickyPB
            mime='application/pdf'
            data={data}
          />
        </div>
        <div className='col-xs-1 pdf-gutter' />
      </div>
    )
  }
}

class GrandRounds extends React.Component {
  constructor (props) {
    super(props)
    this.onSubmit = this.onSubmit.bind(this)
  }

  onSubmit (formData) {
    const { dispatch, encounter, navigate } = this.props

    const data = {
      ...formData,
      type: 'grandRounds',
      supervisor: this.props.supervisor,
      medicalDirector: this.props.medicalDirector
    }

    dispatch(encounterSign(encounter, data, navigate, null))
  }

  render () {
    const {
      encounter,
      medicalDirector,
      supervisor,
      userManagingOrg,
      clientOrg,
      clientAttributes,
      clientName
    } = this.props

    if (encounter) {
      const resource = encounter.subject_id
      const path = 'grandrounds'
      const draft = {
        resource,
        path
      }
      return (
        <div>
          <h2>Grand Rounds Report</h2>
          <RenderDoc {...this.props} />
          <Paper>
            <SignEncounterForm
              clientName={clientName}
              encounter={encounter}
              medicalDirector={medicalDirector}
              supervisor={supervisor}
              userManagingOrg={userManagingOrg}
              clientOrg={clientOrg}
              clientAttributes={clientAttributes}
              onSign={this.onSubmit}
              draft={draft}
            />
          </Paper>
        </div>
      )
    }
    return <CircularProgress />
  }
}

const mapStateToProps = redux => {
    const clientName = redux?.patient?.clientName
  const clientOrg = _.chain(redux)
    .get('globalVars.clients', [])
    .find(c => c.clientName === clientName)
    .get('organization', '')
    .value()

  const clientAttributes = _.chain(redux)
    .get('globalVars.clients', [])
    .find(c => c.clientName === clientName)
    .get('attributes', '')
    .value()

  return {
      signed: redux?.encounter?.signed,
      encounter: redux?.encounter?.encounter,
      loading: redux?.encounter?.grandRoundsLoading,
      data: redux?.encounter?.grandRoundsReportData,
      patientId: redux?.patient?.id,
      supervisor: redux?.auth?.profile?.app_metadata?.supervisor,
      medicalDirector: redux?.auth?.profile?.app_metadata?.medical_director,
      userManagingOrg: redux?.auth?.profile?.app_metadata?.partner_organization,
    clientOrg,
    clientAttributes,
    clientName
  }
}

export default connect(mapStateToProps)(withLegacyRouter(GrandRounds))
